import {gsap} from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || window.matchMedia('(pointer:coarse)').matches;

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.js-fadein-group').forEach(group => {
    gsap.fromTo(group.children, // groupの子要素にアニメーションを適用
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        stagger: 0.1,
        ease: "power4.out",
        duration: 1.5,
        scrollTrigger: {
          trigger: group,
          start: "top 80%",
        },
      }
    );
  });

  document.querySelectorAll('.js-fadein-left-group').forEach(group => {
    gsap.fromTo(group.children, // groupの子要素にアニメーションを適用
      {
        x: 10,
        autoAlpha: 0,
      },
      {
        x: 0,
        autoAlpha: 1,
        stagger: 0.1,
        ease: "power4.out",
        duration: 1,
        scrollTrigger: {
          trigger: group,
          start: "top 80%",
        },
      }
    );
  });

  document.querySelectorAll('.js-fadein').forEach(element => {
    gsap.fromTo(element,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        ease: "power4.out",
        duration: 1.5,
        scrollTrigger: {
          trigger: element, // この要素をトリガーとして使用
          start: "top 80%",
        },
      }
    );
  });

  document.querySelectorAll('.js-heading-animation').forEach(element => {
    gsap.fromTo(element,
      {
        y: 10,
        autoAlpha: 0,
      },
      {
        y: 0,
        autoAlpha: 1,
        ease: "power4.out",
        duration: 1.5,
        scrollTrigger: {
          trigger: element, // この要素をトリガーとして使用
          start: "top 80%",
        },
      }
    );
  });

  document.querySelectorAll('.js-expand-on-scroll').forEach(element => {
    gsap.fromTo(element,
      {
        marginLeft: '5vw',
        marginRight: '5vw'
      },
      {
        marginLeft: 0,
        marginRight: 0,
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end:'bottom 20%',
          scrub: true,
        },
      }
    );
    gsap.to(element.children,
      {
        transform: 'scale(1.15)',
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end:'bottom 20%',
          scrub: true,
        },
      }
    );
  });

  document.querySelectorAll('.js-parallax-image, .is-style-parallax').forEach(element => {
    const intensity = parseFloat(element.dataset.intensity) || 1;
    const img = element.querySelector(':scope > img, :scope > iframe');
    if ( img && !isTouchDevice ) {
      gsap.fromTo(img,
        {
          scale: 1.2, // 開始時のスケール
          y: (i, target) => {
            // 要素の高さとスケールに基づいて、移動距離を計算
            let moveDistance = target.offsetHeight * 0.1;
            return -moveDistance;
          },
        },
        {
          scale: 1.2, // 終了時も同じスケールを保持
          y: (i, target) => {
            // 要素の高さとスケールに基づいて、移動距離を計算
            let moveDistance = target.offsetHeight * 0.1 * intensity;
            return moveDistance;
          },
          ease: "none",
          scrollTrigger: {
            trigger: element,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        }
      );
    };
  });
});

// オープニング
document.addEventListener('DOMContentLoaded', () => {
  // フロントページでのみ実行
  const body = document.querySelector('body');
  if ( ! body.classList.contains('home') ) return;

  const loading = document.querySelector('.home .c-loading');
  const logo = document.querySelector('.home .c-loading h1');
  const reserveButton = document.querySelector('.home .c-reserve-button');
  const hamburger = document.querySelector('.home .c-hamburger');
  const fixedNav = document.querySelector('.home .c-fixed-nav');
  const mvImage = document.querySelector('.home .p-mainvisual > img');

  const TL = gsap.timeline({delay: 0.5});

  if ( window.matchMedia( '( min-width: 768px )' ).matches) {
    TL.to(logo, { duration: 1.5, autoAlpha: 1 }, 'first')
      .to(logo, { duration: 1, autoAlpha: 0 }, 'first+=1.5')
      .to(loading, { duration: 1, autoAlpha: 0 }, 'open')
      .fromTo(mvImage, { scale: 1.3 }, { duration: 1, scale: 1.2, ease: "power4.out" }, 'open')
      .fromTo(reserveButton, { autoAlpha: 0, x: 20 }, { duration: 0.5, autoAlpha: 1, x: 0, ease: 'back.out(2)' }, 'open+=0.5')
      .fromTo(hamburger, { autoAlpha: 0, x: -20 }, { duration: 0.5, autoAlpha: 1, x: 0, ease: 'back.out(2)' }, 'open+=0.5');
  } else {
    TL.to(logo, { duration: 1.5, autoAlpha: 1 }, 'first')
      .to(logo, { duration: 1, autoAlpha: 0 }, 'first+=1.5')
      .to(loading, { duration: 1, autoAlpha: 0 }, 'open')
      .fromTo(mvImage, { scale: 1.3 }, { duration: 1, scale: 1.2, ease: "power4.out" }, 'open')
      .fromTo(reserveButton, { autoAlpha: 0, y: 20 }, { duration: 1, autoAlpha: 1, y: 0 }, 'open+=0.5')
      .fromTo(fixedNav, { autoAlpha: 0, y: 20 }, { duration: 1, autoAlpha: 1, y: 0 }, 'open+=0.5')
  }
});

// リサイズ時のハンバーガーメニューの調整

document.addEventListener('DOMContentLoaded', () => {
  let isMobile = window.matchMedia("(max-width: 767px)").matches;

  const adjustVisibility = () => {
    const nowIsMobile = window.matchMedia("(max-width: 767px)").matches;

    // SPからPCに変更されたとき
    if (isMobile && !nowIsMobile) {
      // 即時表示
      gsap.set('.c-hamburger', { autoAlpha: 1 });
    }
    // PCからSPに変更されたとき
    else if (!isMobile && nowIsMobile) {
      // 遅延なしで非表示
      gsap.to('.c-hamburger', { duration: 0, autoAlpha: 0 });

    }

    isMobile = nowIsMobile;
  };

  // ウィンドウのリサイズイベントに対して処理を登録
  window.addEventListener('resize', adjustVisibility);
});
